module.exports = __webpack_public_path__ + "img/22_2025_04_24.433de328.jpg";